import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { QueryCaptchaCode, VerifyCodeVo, GenerateVo, SellerAPIVo, WebhookEventItem, webhookEventSubscribedItem } from './types';
/**
 * api 发送验证码
 */
export const sendApiVerifyCode = (data: QueryCaptchaCode): AxiosPromise<VerifyCodeVo> => {
  return request({
    url: '/member/api/sendVerifyCode',
    method: 'post',
    data
  });
};

/**
 * 生成AppSecret AppKey
 */

export const generate = (data?: { code: string }): AxiosPromise<GenerateVo> => {
  return request({
    url: '/member/api/generate',
    method: 'post',
    data
  });
};

/**
 * 编辑api webhook 地址
 */

export const eventUrl = (data?: { code: string; webhookUrl: string }): AxiosPromise<boolean> => {
  return request({
    url: '/member/api/eventUrl',
    method: 'post',
    data
  });
};
/**
 * api申请
 */
export const apiApply = (data?: { registerReason: string }): AxiosPromise<boolean> => {
  return request({
    url: '/member/api/apply',
    method: 'post',
    data
  });
};

/**
 * 申请api信息
 */
export const apiInfo = (): AxiosPromise<SellerAPIVo> => {
  return request({
    url: '/member/api/apiInfo',
    method: 'get'
  });
};

/**
 * 事件列表
 */
export const getWebhookEvent = (): AxiosPromise<WebhookEventItem[]> => {
  return request({
    url: '/member/api/webhook/event',
    method: 'get'
  });
};

/**
 * 检查webhook地址是否无效
 */
export const getWebhookUrlCheck = (url: string): AxiosPromise<boolean> => {
  return request({
    url: '/member/api/webhook/url/check',
    method: 'get',
    params: { url }
  });
};

/**
 * 查询已订阅的webhook事件
 */
export const getWebhookEventSubscribed = (): AxiosPromise<webhookEventSubscribedItem[]> => {
  return request({
    url: '/member/api/webhook/event/subscribed',
    method: 'get'
  });
};

/**
 * 更新webhook地址
 */
export const upWebhookUrl = (data?: { webhookUrl: string }) => {
  return request({
    url: '/member/api/webhook/url',
    method: 'post',
    data
  });
};

/**
 * 更新webhook订阅事件
 */
export const upWebhookEventSubscribed = (data?: { events: number[] }) => {
  return request({
    url: '/member/api/webhook/event/subscribed',
    method: 'post',
    data
  });
};
